/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState, useRef, useLayoutEffect } from "react";
import { Paper, IconButton } from "@mui/material";
import { useClickAway } from "hooks/useClickAway";
import LabelledField from "components/labelled-field";
import ModalDialog from "components/info-button-popover/modal-dialog";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTheme } from "@mui/material/styles";
import { Logger } from "cms/utils/log/logger";

const ImageInfoPanel = (props) => {
    
    const { image } = props;
    const [info, setInfo] = useState(false);
    const [location, setLocation] = useState({ top: 0, left: 0 });
    const wrapperRef = useRef();
    const infoButtonRef = useRef();
    const theme = useTheme();
    const buttonStyle = { color: theme.palette.grey["400"] };
    
    const openInfo = async () => {
        setInfo(!info);
        Logger.debug(location);
    };
    const closeInfo = async () => {
        setInfo(false);
    };
    useClickAway(wrapperRef, closeInfo);

    useLayoutEffect(() => {
        // the ref can not be read until the image has been added [image in deps]
        if (infoButtonRef?.current) {
            const left = (infoButtonRef?.current?.offsetLeft || 0) - 10;
            const top = (infoButtonRef?.current?.offsetTop || 0) + 30;
            setLocation({
                left,
                top,
            });
        }
    }, [image,infoButtonRef]);
    
    const { width, height, title, alt, description, file_type } = image || {};
    const dimensions = width && height ? `${width}x${height}` : "Not recorded";
    
    return (
        <div ref={wrapperRef}>
            <IconButton
                ref={infoButtonRef}
                style={buttonStyle}
                aria-label='upload image'
                component='span'
                onClick={openInfo}
            >
                <InfoOutlinedIcon />
            </IconButton>
            {info &&
                <ModalDialog
                    location={location}
                    zIndex={998}
                    aria-labelledby='modal-modal-title'
                    aria-describedby='modal-modal-description'
                >
                    <Paper elevation={3} className='image-info-box'>
                        <LabelledField label='Title' variant='subtitle1'>
                            <span className='info-text'>{title}</span>
                        </LabelledField>
                        <LabelledField label='Alt Text' variant='subtitle1'>
                            <span className='info-text'>{alt}</span>
                        </LabelledField>
                        <LabelledField label='Caption' variant='subtitle1'>
                            <span className='info-text'>{description}</span>
                        </LabelledField>
                        <LabelledField label='File Type' variant='subtitle1'>
                            <span className='info-text'>{file_type}</span>
                        </LabelledField>
                        <LabelledField label='Dimensions' variant='subtitle1'>
                            <span className='info-text'>{dimensions}</span>
                        </LabelledField>
                    </Paper>
                </ModalDialog>
            }
        </div>
    );
};

export { ImageInfoPanel };
